import { Injectable, signal } from '@angular/core';
import { ScheduleDay } from '../models/models';

@Injectable({ providedIn: 'root' })
export class ScheduleService {
  private readonly schedule = signal<ScheduleDay[]>([
    {
      title: 'Thursday',
      datetime: '2025-11-06',
      entries: [
        // Registration - 08:30-09:30
        {
          title: 'Registration & Light Refreshments',
          datetime: '2025-11-06T08:30:00',
          information: 'Registration with coffee and small snacks',
          location: 'Both Stages',
          session: null
        },
        // Opening & Welcome - 09:30-10:00
        {
          title: 'Opening & Welcome',
          datetime: '2025-11-06T09:30:00',
          information: 'Robin Böhm and MC',
          location: 'Pool House',
          session: null
        },
        {
          title: 'Opening & Welcome',
          datetime: '2025-11-06T09:30:00',
          information: 'Live Stream of Pool House Stage 📺🍿',
          location: 'Aula',
          session: null
        },
        // Keynote - 10:00-10:30
        {
          title: 'Keynote',
          datetime: '2025-11-06T10:00:00',
          information: 'Mark Thompson - tbd',
          location: 'Pool House',
          session: 'keynote-day1'
        },
        {
          title: 'Keynote',
          datetime: '2025-11-06T10:00:00',
          information: 'Live Stream of Pool House Stage 📺🍿',
          location: 'Aula',
          session: null
        },
        // Slot 2 - 10:30-11:00
        {
          title: 'Talk',
          datetime: '2025-11-06T10:30:00',
          information: 'Matthieu Riegler - tbd',
          location: 'Pool House',
          session: 'talk-day1-2'
        },
        {
          title: 'Talk',
          datetime: '2025-11-06T10:30:00',
          information: 'Live Stream of Pool House Stage 📺🍿',
          location: 'Aula',
          session: null
        },
        // Coffee Break - 11:00-11:45
        {
          title: 'Coffee Break ☕️',
          datetime: '2025-11-06T11:00:00',
          information: 'Networking opportunity',
          location: 'Both Stages',
          session: null
        },
        // Slot 3 - 11:45-12:15 - Two different talks
        {
          title: 'Talk',
          datetime: '2025-11-06T11:45:00',
          information: 'Enea Jahollari',
          location: 'Pool House',
          session: 'talk-day1-8'
        },
        {
          title: 'Talk',
          datetime: '2025-11-06T11:45:00',
          information: 'Jim Sellmeijer',
          location: 'Aula',
          session: 'jim-ai-talk'
        },
        // Slot 4 - 12:25-12:55
        {
          title: 'Talk',
          datetime: '2025-11-06T12:30:00',
          information: 'Marko Stanimirović',
          location: 'Pool House',
          session: 'talk-day1-4'
        },
        {
          title: 'Talk',
          datetime: '2025-11-06T12:30:00',
          information: 'Gregor Woiwode',
          location: 'Aula',
          session: 'talk-agentic-angular'
        },
        // Lunch - 13:00-14:15
        {
          title: 'Lunch Break 🍽️',
          datetime: '2025-11-06T13:00:00',
          information: 'Restaurant Oderberger',
          location: 'Both Stages',
          session: null
        },
        // Slot 5 - 14:15-14:45 - Two different talks
        {
          title: 'Talk',
          datetime: '2025-11-06T14:15:00',
          information: 'Kasia Biernat-Kluba',
          location: 'Pool House',
          session: 'talk-day1-5'
        },
        {
          title: 'Talk',
          datetime: '2025-11-06T14:15:00',
          information: 'Mario Trzensky',
          location: 'Aula',
          session: 'talk-cologne-intelligence-ai-ux'
        },
        // Slot 6 - 14:55-15:25 - Parallel Sessions
        {
          title: 'Talk',
          datetime: '2025-11-06T15:00:00',
          information: 'Eliran Eliassy',
          location: 'Pool House',
          session: 'talk-day1-6'
        },
        {
          title: 'Talk',
          datetime: '2025-11-06T15:00:00',
          information: 'Robin Götz',
          location: 'Aula',
          session: 'talk-day1-3'
        },
        // Coffee Break - 15:30-16:00
        {
          title: 'Coffee Break ☕️',
          datetime: '2025-11-06T15:30:00',
          information: 'Networking opportunity',
          location: 'Both Stages',
          session: null
        },
        // Slot 7 - 16:00-16:30
        {
          title: 'Talk',
          datetime: '2025-11-06T16:00:00',
          information: 'Martina Kraus',
          location: 'Pool House',
          session: 'talk-day1-7'
        },
        {
          title: 'Talk',
          datetime: '2025-11-06T16:00:00',
          information: 'Robin Böhm',
          location: 'Aula',
          session: 'talk-process-automation-ai-agents'
        },
        // Slot 8 - 16:45-17:30
        {
          title: 'Panel Discussion',
          datetime: '2025-11-06T16:45:00',
          information: 'Various speakers',
          location: 'Pool House',
          session: 'panel-angular-ai-forward'
        },
        {
          title: 'Panel Discussion',
          datetime: '2025-11-06T16:45:00',
          information: 'Live Stream of Pool House Stage 📺🍿',
          location: 'Aula',
          session: null
        },
        // Closing & Preparation - 17:30-18:00
        {
          title: 'Closing Day 1 & Break',
          datetime: '2025-11-06T17:30:00',
          information: 'Preparation of the Pool Hall for 🎉',
          location: 'Both Stages',
          session: null
        },
        // Community Event - 18:00-19:30
        {
          title: 'Community Event 🎉',
          datetime: '2025-11-06T18:00:00',
          information: 'Drinks, Food, Music, Tablesoccer Tournament, Networking',
          location: 'Both Stages',
          session: null
        },
        // Open Stage - 19:30-20:30
        {
          title: 'Open Stage / PowerPoint Karaoke 🎤',
          datetime: '2025-11-06T19:30:00',
          information: 'Interactive entertainment',
          location: 'Both Stages',
          session: null
        },
        // Late Evening - 20:30-22:00
        {
          title: 'Community Event 🎉',
          datetime: '2025-11-06T20:30:00',
          information: 'Drinks, Music, Tablesoccer Tournament, Networking',
          location: 'Both Stages',
          session: null
        },
        // Location Closes - 22:00
        {
          title: 'Location Closes 🌙',
          datetime: '2025-11-06T22:00:00',
          information: 'End of Day 1',
          location: 'Both Stages',
          session: null
        }
      ]
    },
    {
      title: 'Friday',
      datetime: '2025-11-07',
      entries: [
        // Registration - 09:00-09:30
        {
          title: 'Registration & Breakfast',
          datetime: '2025-11-07T09:00:00',
          information: 'Registration and breakfast',
          location: 'Both Stages',
          session: null
        },
        // Opening - 09:30-10:00
        {
          title: 'Opening & Welcome',
          datetime: '2025-11-07T09:30:00',
          information: 'Opening Day 2',
          location: 'Pool House',
          session: null
        },
        {
          title: 'Opening & Welcome',
          datetime: '2025-11-07T09:30:00',
          information: 'Live Stream of Pool House Stage 📺🍿',
          location: 'Aula',
          session: null
        },
        // Keynote - 10:00-10:30
        {
          title: 'Keynote',
          datetime: '2025-11-07T10:00:00',
          information: 'Jens Kühlers',
          location: 'Pool House',
          session: 'keynote-day2'
        },
        {
          title: 'Keynote',
          datetime: '2025-11-07T10:00:00',
          information: 'Live Stream of Pool House Stage 📺🍿',
          location: 'Aula',
          session: null
        },
        // Slot 11 - 10:30-11:00
        {
          title: 'Talk',
          datetime: '2025-11-07T10:30:00',
          information: 'Component Testing That Feels Like Playwright',
          location: 'Pool House',
          session: 'talk-day2-16',
          speakers: ['Younes Jaaidi', 'Rainer Hahnekamp']
        },
        {
          title: 'Talk',
          datetime: '2025-11-07T10:30:00',
          information: 'Naoufal El Hassnaoui',
          location: 'Aula',
          session: 'talk-cursor-ai-agents'
        },
        // Coffee Break - 11:00-11:45
        {
          title: 'Coffee Break ☕️',
          datetime: '2025-11-07T11:00:00',
          information: 'Networking opportunity',
          location: 'Both Stages',
          session: null
        },
        // Slot 12 - 11:45-12:15
        {
          title: 'Talk',
          datetime: '2025-11-07T11:45:00',
          information: 'Michael Hladky',
          location: 'Pool House',
          session: 'talk-day2-15'
        },
        {
          title: 'Talk',
          datetime: '2025-11-07T11:45:00',
          information: 'Maria Korneeva',
          location: 'Aula',
          session: 'talk-day2-11'
        },
        // Slot 13 - 12:25-12:55
        {
          title: 'Talk',
          datetime: '2025-11-07T12:30:00',
          information: 'Brygida Fiejdasz',
          location: 'Pool House',
          session: 'talk-day2-13'
        },
        {
          title: 'Talk',
          datetime: '2025-11-07T12:30:00',
          information: 'Mussie Haile',
          location: 'Aula',
          session: 'talk-rapid-prototyping-ai'
        },
        // Lunch - 13:00-14:15
        {
          title: 'Lunch Break & Group Photo 📸',
          datetime: '2025-11-07T13:00:00',
          information: 'Lunch & Gruppenfoto',
          location: 'Both Stages',
          session: null
        },
        // Slot 14 - 14:15-14:45
        {
          title: 'Talk',
          datetime: '2025-11-07T14:15:00',
          information: 'Tobias Brenner',
          location: 'Pool House',
          session: 'talk-eon-microfrontends'
        },
        {
          title: 'Talk',
          datetime: '2025-11-07T14:15:00',
          information: 'Christian Liebel',
          location: 'Aula',
          session: 'talk-day2-14'
        },
        // Slot 15 - 14:55-15:25
        {
          title: 'Talk',
          datetime: '2025-11-07T15:00:00',
          information: 'Manfred Steyer',
          location: 'Pool House',
          session: 'talk-day2-18'
        },
        {
          title: 'Talk',
          datetime: '2025-11-07T15:00:00',
          information: 'Nicolas Frizzarin',
          location: 'Aula',
          session: 'talk-day2-17'
        },
        // Coffee Break - 15:30-16:00
        {
          title: 'Coffee Break ☕️',
          datetime: '2025-11-07T15:30:00',
          information: 'Networking opportunity',
          location: 'Both Stages',
          session: null
        },
        // Slot 16 - 16:45-17:30
        // Slot 17 - 16:45-17:30
        {
          title: 'Panel Discussion',
          datetime: '2025-11-07T16:00:00',
          information: 'Various speakers',
          location: 'Pool House',
          session: 'panel-angular-team'
        },
        {
          title: 'Panel Discussion',
          datetime: '2025-11-07T16:00:00',
          information: 'Live Stream of Pool House Stage 📺🍿',
          location: 'Aula',
          session: null
        },
        // Closing - 17:30
        {
          title: 'Closing & Farewell',
          datetime: '2025-11-07T17:00:00',
          information: 'Orga Team / MC',
          location: 'Both Stages',
          session: null
        }
      ]
    }
  ]);

  /**
   * Returns the signal containing the conference schedule
   */
  getSchedule() {
    return this.schedule;
  }

  /**
   * Returns a schedule day by date
   */
  getScheduleByDay(date: string): ScheduleDay | undefined {
    return this.schedule().find(day => day.datetime === date);
  }
}